import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';

import { OrderedJoinServiceBase } from '../../shared/base/ordered-join-service-base';

@Injectable()
export class LectureLessonService extends OrderedJoinServiceBase {
  constructor(db: AngularFireDatabase) {
    super(db, '/lecture-lessons', '/lessons');
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/shared/lecture-lesson.service.ts